import type { FC } from 'react';
import type { PrivacyListType } from 'types/types';

export interface IPrivacyPolicyItem {
  privacyPolicies: PrivacyListType[];
}
const PrivacyPolicyItem: FC<IPrivacyPolicyItem> = ({ privacyPolicies }) => {
  return (
    <div>
      {privacyPolicies.map((listItem, index) => (
        <div key={index.toString()} className="privacy-policy-list_item">
          <div className="privacy-policy-list_description">
            {listItem.description}
          </div>
          {listItem && (
            <ol>
              {listItem?.innerList?.map((item, index) => (
                <li key={index.toString()}>{item.description}</li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicyItem;
